<template>
  <Dialog ref="dialog"
          width="600px"
          icon="fas fa-truck"
          title="Resultado modificación">
    <div v-if="hasErrors">
      <div class="dialogError">
        <i class="el-icon-error"/>ALGUNAS SUBORDENES O LPN NO FUERON INCLUIDOS:
      </div>
      <div v-if="hasAddErrors">
        <div  class="dialogSub"><i class="el-icon-circle-plus"/>NO AGREGADAS:</div>
        <div class="dialogItem" v-if="hasNotFoundAddError">
          <span class="totalItemTim">{{notFoundAddError.length}}</span> NO ENCONTRADAS
          <ol class="ordersListStyleDialog">
            <li type="none" v-for="(notFoundA, index) in notFoundAddError"
                :key="index.notFoundAddError">{{notFoundA}}
            </li>
          </ol>
        </div>
        <div class="dialogItem" v-if="hasCanceledAddError">
          <span class="totalItemTim">{{canceledAddError.length}}</span> CON ESTADO CANCELADO
          <ol class="ordersListStyleDialog">
            <li type="none" v-for="(canceledAddErrorA, index) in canceledAddError"
                :key="index.canceledAddError">{{canceledAddErrorA}}
            </li>
          </ol>
        </div>
        <div class="dialogItem" v-if="hasTerminatedAddError">
          <span class="totalItemTim">{{terminatedAddError.length}}</span> CON ESTADO TERMINADO
          <ol class="ordersListStyleDialog">
            <li type="none" v-for="(terminatedAddErrorA, index) in terminatedAddError"
                :key="index.terminatedAddError">{{terminatedAddErrorA}}
            </li>
          </ol>
        </div>
        <div class="dialogItem" v-if="hasInOtherRoutesAddError">
          <span class="totalItemTim">{{inOtherRoutesAddError.length}}</span> EN OTRA RUTA
          <ol class="ordersListStyleDialog">
            <li type="none" v-for="(addFailOtherRoutesA, index) in inOtherRoutesAddError"
                :key="index.inOtherRoutesAddError">{{addFailOtherRoutesA}}
            </li>
          </ol>
        </div>
        <div class="dialogItem" v-if="hasAlreadyInRouteAddError">
          <span class="totalItemTim">{{alreadyInRouteAddError.length}}</span> EN RUTA
          <ol class="ordersListStyleDialog">
            <li type="none" v-for="(addAlreadyInRouteA, index) in alreadyInRouteAddError"
                :key="index.alreadyInRouteAddError">{{addAlreadyInRouteA}}
            </li>
          </ol>
        </div>
      </div>
      <div v-if="hasRemErrors">
        <div class="dialogSub" ><i class="el-icon-remove"></i>NO ELIMINADAS</div>
        <div class="dialogItem" v-if="hasNotFoundRemError">
          <span class="totalItemTim">{{notFoundRemError.length}}</span> NO ENCONTRADAS
          <ol class="ordersListStyleDialog">
            <li type="none" v-for="(notFoundDeleteA, index) in notFoundRemError"
                :key="index.notFoundRemError">{{notFoundDeleteA}}
            </li>
          </ol>
        </div>
        <div class="dialogItem" v-if="hasInOtherRoutesRemError">
          <span class="totalItemTim">{{inOtherRoutesRemError.length}}</span> EN OTRA RUTA
          <ol class="ordersListStyleDialog">
            <li type="none" v-for="(deleteFailOtherRoutesA, index) in inOtherRoutesRemError"
                :key="index.inOtherRoutesRemError">{{deleteFailOtherRoutesA}}
            </li>
          </ol>
        </div>
      </div>
    </div>
    <div v-if="hasAddSuccess">
      <div class="dialogSub"><i class="el-icon-success"></i>SOC AGREGADAS CON ÉXITO
        <span class="totalItemTimSuss">{{addSuccess.length}}</span>
      </div>
      <ol class="dialogItemSuss">
        <li type="none" v-for="(addSuccessA, index) in addSuccess"
            :key="index.addSuccess">{{addSuccessA}}
        </li>
      </ol>
    </div>

    <div v-if="hasAddLpnSuccess">
      <div class="dialogSub"><i class="el-icon-success"></i>LPN AGREGADOS CON ÉXITO
        <span class="totalItemTimSuss">{{addLpnSuccess.length}}</span>
      </div>
      <ol class="dialogItemSuss">
        <li type="none" v-for="(lpn, index) in addLpnSuccess"
            :key="index.addLpnSuccess">{{lpn}}
        </li>
      </ol>
    </div>
    <div v-if="hasRemSuccess">
      <div class="dialogSub"><i class="el-icon-success"></i>SOC ELIMINADAS CON ÉXITO
        <span class="totalItemTimSuss">{{deleteSuccess.length}}</span>
      </div>
      <ol class="dialogItemSuss">
        <li type="none" v-for="(deleteSuccessA, index) in deleteSuccess"
            :key="index.deleteSuccess">{{deleteSuccessA}}
        </li>
      </ol>
    </div>
    <div v-if="hasRemLpnSuccess">
      <div class="dialogSub"><i class="el-icon-success"></i>LPN ELIMINADOS CON ÉXITO
        <span class="totalItemTimSuss">{{deleteLpnSuccess.length}}</span>
      </div>
      <ol class="dialogItemSuss">
        <li type="none" v-for="(lpn, index) in deleteLpnSuccess"
            :key="index.deleteLpnSuccess">{{lpn}}
        </li>
      </ol>
    </div>
    <p v-show="hasAnySuccess"
       class="dialogRec">Recuerda replanificar tu Ruta</p>
  </Dialog>
</template>

<script>
import Dialog from '../base/Dialog.vue';

export default {
  name: 'DialogChangeSummary',
  components: {
    Dialog,
  },
  data() {
    return {
      plate: '-',
      visible: false,
      routeId: NaN,
      notFoundAdd: [],
      notFoundDelete: [],
      addSuccess: [],
      addLpnSuccess: [],
      deleteSuccess: [],
      deleteLpnSuccess: [],
      addFailOtherRoutes: [],
      deleteFailOtherRoutes: [],
      addAlreadyInRoute: [],
      addCanceled: [],
      addTerminated: [],
    };
  },
  computed: {
    hasErrors() {
      return (this.notFoundAdd && this.notFoundAdd.length > 0)
            || (this.addCanceled && this.addCanceled.length > 0)
            || (this.addTerminated && this.addTerminated.length > 0)
            || (this.addFailOtherRoutes && this.addFailOtherRoutes.length > 0)
            || (this.addAlreadyInRoute && this.addAlreadyInRoute.length > 0)
            || (this.notFoundDelete && this.notFoundDelete.length > 0)
            || (this.deleteFailOtherRoutes && this.deleteFailOtherRoutes.length > 0);
    },
    hasAddErrors() {
      return (this.notFoundAdd && this.notFoundAdd.length > 0)
        || (this.addCanceled && this.addCanceled.length > 0)
        || (this.addTerminated && this.addTerminated.length > 0)
        || (this.addFailOtherRoutes && this.addFailOtherRoutes.length > 0)
        || (this.addAlreadyInRoute && this.addAlreadyInRoute.length > 0);
    },
    hasRemErrors() {
      return (this.notFoundDelete && this.notFoundDelete.length > 0)
              || (this.deleteFailOtherRoutes && this.deleteFailOtherRoutes.length > 0);
    },
    hasNotFoundAddError() {
      return this.notFoundAdd && this.notFoundAdd.length > 0;
    },
    notFoundAddError() {
      if (this.notFoundAdd && this.notFoundAdd.length > 0) {
        return this.notFoundAdd;
      }
      return [];
    },
    hasInOtherRoutesAddError() {
      return this.addFailOtherRoutes && this.addFailOtherRoutes.length > 0;
    },
    inOtherRoutesAddError() {
      if (this.addFailOtherRoutes && this.addFailOtherRoutes.length > 0) {
        return this.addFailOtherRoutes;
      }
      return [];
    },
    hasAlreadyInRouteAddError() {
      return this.addAlreadyInRoute && this.addAlreadyInRoute.length > 0;
    },
    alreadyInRouteAddError() {
      if (this.addAlreadyInRoute && this.addAlreadyInRoute.length > 0) {
        return this.addAlreadyInRoute;
      }
      return [];
    },
    hasTerminatedAddError() {
      return this.addTerminated && this.addTerminated.length > 0;
    },
    terminatedAddError() {
      if (this.addTerminated && this.addTerminated.length > 0) {
        return this.addTerminated;
      }
      return [];
    },
    hasCanceledAddError() {
      return this.addCanceled && this.addCanceled.length > 0;
    },
    canceledAddError() {
      if (this.addCanceled && this.addCanceled.length > 0) {
        return this.addCanceled;
      }
      return [];
    },
    hasNotFoundRemError() {
      return this.notFoundDelete && this.notFoundDelete.length > 0;
    },
    notFoundRemError() {
      if (this.notFoundDelete && this.notFoundDelete.length > 0) {
        return this.notFoundDelete;
      }
      return [];
    },
    hasInOtherRoutesRemError() {
      return this.deleteFailOtherRoutes && this.deleteFailOtherRoutes.length > 0;
    },
    inOtherRoutesRemError() {
      if (this.deleteFailOtherRoutes && this.deleteFailOtherRoutes.length > 0) {
        return this.deleteFailOtherRoutes;
      }
      return [];
    },
    hasAddSuccess() {
      return this.addSuccess && this.addSuccess.length > 0;
    },
    hasAddLpnSuccess() {
      return this.addLpnSuccess && this.addLpnSuccess.length > 0;
    },
    hasRemLpnSuccess() {
      return this.deleteLpnSuccess && this.deleteLpnSuccess.length > 0;
    },
    hasRemSuccess() {
      return this.deleteSuccess && this.deleteSuccess.length > 0;
    },
    hasAnySuccess() {
      return (this.addSuccess && this.addSuccess.length > 0)
          || (this.addLpnSuccess && this.addLpnSuccess.length > 0)
          || (this.deleteLpnSuccess && this.deleteLpnSuccess.length > 0)
          || (this.deleteSuccess && this.deleteSuccess.length > 0);
    },
  },
  methods: {
    safeArraySet(key, value) {
      if (Array.isArray(value)) {
        this[key] = [...(new Set(value))];
      } else {
        this[key] = [];
      }
    },
    reset() {
      Object.assign(this, {
        notFoundAdd: [],
        notFoundDelete: [],
        addSuccess: [],
        deleteSuccess: [],
        deleteLpnSuccess: [],
        addFailOtherRoutes: [],
        deleteFailOtherRoutes: [],
        addAlreadyInRoute: [],
        addCanceled: [],
        addTerminated: [],
      });
    },
    showSummary(summary) {
      this.reset();
      // this.visible = true;
      this.$refs.dialog.visible(true);
      if (summary.add_suborders) {
        this.safeArraySet('notFoundAdd', summary.add_suborders.not_found);
        this.safeArraySet('addFailOtherRoutes', summary.add_suborders.is_in_other_route);
        this.safeArraySet('addAlreadyInRoute', summary.add_suborders.already_in_route);
        this.safeArraySet('addCanceled', summary.add_suborders.canceled);
        this.safeArraySet('addTerminated', summary.add_suborders.terminated);
      }
      if (summary.remove_suborders) {
        this.safeArraySet('notFoundDelete', summary.remove_suborders.not_found);
        this.safeArraySet('deleteFailOtherRoutes', summary.remove_suborders.is_in_other_route);
        this.safeArraySet('deleteFailOtherRoutes', summary.remove_suborders.is_in_other_route);
      }
      if (summary.remove_lpn) {
        this.safeArraySet('notFoundDelete', summary.remove_lpn.not_found);
        this.safeArraySet('deleteFailOtherRoutes', summary.remove_lpn.is_in_other_route);
      }
      if (summary.add_lpn) {
        this.safeArraySet('notFoundAdd', summary.add_lpn.not_found);
        this.safeArraySet('addFailOtherRoutes', summary.add_lpn.is_in_other_route);
        this.safeArraySet('addAlreadyInRoute', summary.add_lpn.already_in_route);
        this.safeArraySet('addCanceled', summary.add_lpn.canceled);
        this.safeArraySet('addTerminated', summary.add_lpn.terminated);
      }
      this.safeArraySet('addSuccess', summary.add_success);
      this.safeArraySet('addLpnSuccess', summary.add_lpn_success);
      this.safeArraySet('deleteSuccess', summary.remove_success);
      this.safeArraySet('deleteLpnSuccess', summary.remove_lpn_success);
    },
  },
};
</script>

<style lang="scss" scoped>
  .btnSearch{
    height: 40px;
  }
  .rowRoutePatent{
    display: table;
    margin-top: -20px;
    height:20px;
    margin-left: 30px;
    margin-bottom: 0px;
    text-align: left;
  }
  .el-icon-truck {
    margin-right: 10px;
    font-size: 20px;
    color: #c0c4cc;
    display: table-cell;
    vertical-align: middle;
  }
  .titleStyle {
    font-size: 11px;
    color: #707070;
    text-transform: uppercase;
    margin: 0 30px 0 0;
    font-weight: normal;
  }
  .titleStyleCV {
    font-size: 12px;
    color: #9B9B9B;
    text-transform: uppercase;
    margin: 15px 0 5px 50px;
    font-weight: normal;
    text-align: left;
  }
  .contentMap {
    width: 100%;
    height: 30vh !important;
  }
  .el-input__inner{
    width: 200px;
  }
  el-form el-form--inline{
    text-align: left;
  }
  .topTitle {
    text-transform: uppercase;
    font-size: 14px;
    text-align: left;
    margin: 0 0 1.2em;
  }
  .focus {
    text-transform: uppercase;
    font-weight: 900;
    color: #AAD500;
    &.small {
      display: block;
      font-style: italic;
      margin-top: 0.5em;
      font-size: 0.85em;
    }
  }
  .input {
    margin: 8px 0 16px 0;
  }
  .dialogText {
    width: 85%;
    margin: auto;
    .focus {
      display: block;
    }
  }
  .dialogItem {
    width: 85%;
    font-size: 11px;
    text-align: left;
    margin: 5px 0 5px 20px;
    .focus {
      display: block;
    }
  }
  .btnBottom {
    margin-top: 10px;
    float: right;
  }
  .tableStyle {
    box-sizing: border-box;
    overflow: hidden;
  }
  .grey {
    background-color: #606266;
    align-self: flex-end;
    height: 40px;
  }
  .titleStyleNumRoutes {
    font-size: 13px;
    color: #AAD500;
    font-weight: 600;
    text-transform: uppercase;
    margin: 0 0 10px 0px;
  }
  .linkStyle {
    color: #AAD500;
    border: none;
    font-weight: 600;
    font-size: 15px;
    outline: none;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.0);
    margin: 0;
    padding: 0;
  }
  .dialogTitle {
    padding: 0 40px;
    font-size: 1.2em;
    text-transform: uppercase;
    font-weight: 700;
    margin-top: 0;
    .el-icon-edit {
      color: #AAD500;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-warning {
      color: #F5A623;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-truck {
      color: #AAD500;
      font-size: 1.2em;
      margin-right: 0.5em;
      padding-right: 5px;
      vertical-align: baseline;
    }
  }
  .dialogRec {
    padding: 0 40px;
    font-size: 1em;
    text-transform: uppercase;
    font-weight: 700;
    margin: 30px 0 0 0;
  }
  .dialogSub {
    padding: 10px 40px 0 0;
    text-align: left;
    font-size: 1em;
    text-transform: uppercase;
    font-weight: 500;
    margin-top: 0;
    .el-icon-circle-plus {
      color: #F5A623;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-remove {
      color: #F5A623;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .el-icon-success {
      color: #AAD500;
      font-size: 1.4em;
      margin-right: 0.5em;
    }
    .ordersListStyleDialog {
      font-size: 11px;
      text-align: left;
    }
    .dialogTotalTim {
      padding: 10px 40px 0 0;
      text-align: center;
      font-size: 1em;
      text-transform: uppercase;
      font-weight: 800;
      margin-top: 0;
    }
  }
  .dialogError {
    padding: 10px 40px 0 0px;
    text-align: left;
    font-size: 1.2em;
    text-transform: uppercase;
    font-weight: 700;
    margin-top: 0;
    .el-icon-error {
      color: #f4511e;
      font-size: 1.2em;
      margin: 0 0.5em 0 0;
    }
  }
  .totalItemTim{
    color: white;
    font-size: 10px;
    background: #F5A623;
    border-radius: 100%;
    -moz-border-radius: 1em;
    -webkit-border-radius: 1em;
    display: inline-block;
    font-weight: bold;
    line-height: 1.3em;
    margin-right: 14px;
    margin-left: 10px;
    text-align: center;
    width: 2.4em;
  }
  .totalItemTimSuss{
    color: white;
    font-size: 12px;
    background: #AAD500;
    border-radius: 100%;
    -moz-border-radius: 1em;
    -webkit-border-radius: 1em;
    display: inline-block;
    font-weight: bold;
    line-height: 1.3em;
    margin-right: 14px;
    margin-left: 10px;
    margin-top: 5px;
    text-align: center;
    width: 2.4em;
  }
  .ordersListStyleDialog{
    margin-left: 10px;
  }
  .dialogItemSuss{
    width: 85%;
    font-size: 11px;
    text-align: left;
    margin: 5px 0 5px 30px;
    .focus {
      display: block;
    }
  }
  .clickeable {
    font-size: 7px;
    padding-top: 1px;
    margin-right: 3px;
    height: 23px;
    float: right;
    color: darkgray;
    cursor: pointer;
    animation: jumps .5s infinite;
  }
  .clickeable:hover {
    color: #AAD500;
    animation: none;
  }
  @keyframes jumps {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(4px);
    }
    100% {
      transform: translateY(0px);
    }
  }
  td {
    padding: 2px 0px !important;
  }
  .point-map {
    color: #E6A23C;
    font-size: 8px;
    top: -2px;
  }
  .spCla {
    font-size: 10px;
    color: #707070;
    vertical-align: middle;
    margin-left: 6px;
  }

  .rotate-1 {
    webkit-animation: rotating 5s linear infinite;
    animation: rotating 5s linear infinite;
  }

  .el-icon-refresh-right {
    padding: 3px;
    color: white;
    border-radius: 50%;
    background-color: #09558f;
  }

  .refresh-send {
    font-size: 15px;
    color: #AAD500;
    background-color: transparent;
  }
</style>
